import Swal from "sweetalert2"

export const successUI = (message = "Client saved successfully!") => {
  Swal.fire({
    icon: "success",
    title: "Success",
    text: message,
    confirmButtonColor: "#28a745",
    confirmButtonText: "OK",
    timer: 2000,
    timerProgressBar: true,
  });
};

export const errorUI = (message = "Something went wrong!") => {
  Swal.fire({
    icon: "error",
    title: "Failed",
    text: message,
    confirmButtonColor: "#e53935",
    confirmButtonText: "Try Again",
  });
};

export const requireUI = (message = "All Fields Required!") => {
  Swal.fire({
    icon: "warning", // changed from success
    title: "Required",
    text: message,
    confirmButtonColor: "#ffc107",
    confirmButtonText: "OK",
    timer: 2000,
    timerProgressBar: true,
  });
};
